import { render, staticRenderFns } from "./DeliveryOrderDetail.vue?vue&type=template&id=7b4c1840&scoped=true"
import script from "./DeliveryOrderDetail.vue?vue&type=script&lang=js"
export * from "./DeliveryOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./DeliveryOrderDetail.vue?vue&type=style&index=0&id=7b4c1840&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4c1840",
  null
  
)

export default component.exports